export const MDSColors = {
  // Primitive Colors
  paper: "#FFFFFF",
  black: "#000000",
  success: "#23B688",
  successLight: "#D8F8EE",
  transparent: "transparent",
  transparentCanvas: "rgba(252, 248, 241, 0.25)",
  transparentInk: "rgba(39, 38, 56, 0.5)",
  ink: {
    0: "#D6D5E6",
    100: "#A5A3D0",
    200: "#7977BA",
    300: "#413F8E",
    400: "#100F31",
  },
  inkDark: {
    0: "#11111A",
    50: "#1A1925",
    100: "#20202F",
    150: "#272638",
    200: "#2E2D41",
    300: "#3C3B54",
    400: "#4C4B67",
    500: "#504F6D",
    600: "#89889F",
    700: "#D6D6E6",
  },
  graphite: {
    0: "#FEFEFE",
    100: "#F6F6F6",
    200: "#E9E9E9",
    300: "#DDDDDD",
    400: "#CECECE",
    500: "#BDBDBD",
    600: "#9C9C9C",
    700: "#7A7A7A",
    800: "#595959",
    900: "#373737",
  },
  graphiteDark: {
    0: "#262626",
    100: "#2E2E2E",
    200: "#353535",
    300: "#3C3C3C",
    400: "#525252",
    500: "#616161",
    600: "#7F7F7F",
    700: "#9C9C9C",
    800: "#B9B9B9",
    900: "#D7D7D7",
  },
  canvas: {
    0: "#FCF8F1",
    100: "#F9F1E4",
  },
  blueprint: {
    0: "#F6F8FF",
    100: "#E6EDFF",
    200: "#A6BFFF",
    300: "#6792FF",
    400: "#3D69D9",
    500: "#1D47B3",
  },
  blueprintDark: {
    0: "#191930",
    100: "#1E2242",
    200: "#23284C",
    300: "#2A305A",
    400: "#303768",
  },
  latte: {
    0: "#F9F1E2",
    100: "#F1E7D3",
    200: "#E8DCC4",
    300: "#E4D6B9",
  },
  editor: {
    0: "#FFE8E6",
    100: "#FFB5AB",
    200: "#FF8170",
    300: "#FF5C45",
    400: "#FF361A",
    500: "#DB1A00",
  },
  editorDark: {
    0: "#3F1A1F",
    100: "#5F272F",
    200: "#8E404B",
    300: "#B8626F",
    400: "#D9818E",
  },

  // Semantic Variables - Setting everything to yellow first
  text: {
    contrast: "#FFFF00",
    primary: "#FFFF00",
    secondary: "#FFFF00",
    tertiary: "#FFFF00",
    onAccent: "#FFFF00",
    emphasis: "#FFFF00",
    positive: "#FFFF00",
    danger: "#FF0000",
    link: {
      default: "#FFFF00",
      hover: "#FFFF00",
    },
    editor: {
      metadata: "#FF0000", // TODO: Not in Figma
    },
  },
  icon: {
    primary: "#FFFF00",
    secondary: "#FFFF00",
    placeholder: "#FFFF00",
    onAccent: "#FFFF00",
    brand: "#FFFF00",
    selected: "#FFFF00",
    emphasis: "#FFFF00",
    danger: "#FFFF00",
    positive: "#FFFF00", // TODO: Not in Figma
    onChromeInactive: "#FFFF00",
  },
  surface: {
    chrome: "#FFFF00",
    pane: "#FFFF00",
    paneHeader: "#FFFF00",
    chat: "#FFFF00",
    menu: "#FFFF00",
    modal: "#FFFF00",
    popover: "#FFFF00",
    preview: "#FFFF00",
    previewHeader: "#FFFF00",
    tooltip: "#FFFF00",
    onboarding: "#FFFF00",
    onboardingSubtle: "#FFFF00",
    headsUp: {
      default: "#FFFF00",
      hover: "#FFFF00",
    },
    toast: {
      default: "#FFFF00",
      danger: "#FFFF00",
    },
    overlay: {
      default: "#FFFF00",
      onboarding: "#FFFF00",
    },
  },
  border: {
    default: "#FFFF00",
    onAccent: "#FFFF00",
    ghost: "#FFFF00",
    surface: "#FFFF00",
    emphasis: "#FFFF00",
    chrome: "#FFFF00",
    input: {
      default: {
        default: "#FFFF00",
        focused: "#FFFF00",
        danger: "#FF0000",
      },
      brand: {
        default: "#FFFF00",
        focused: "#FFFF00",
      },
      emphasis: {
        default: "#FFFF00",
        focused: "#FFFF00",
      },
    },
    button: {
      marketing: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
    },
  },
  background: {
    activeTab: "#FFFF00",
    diff: "#FFFF00",
    codeBlock: "#FFFF00",
    textHighlight: "#FFFF00",
    inlineCode: "#FFFF00",
    list: {
      default: "#FFFF00",
      hover: "#FFFF00",
      selected: "#FFFF00",
      deepsearch: "#FFFF00",
      uploading: "#FFFF00",
      pending: "#FFFF00",
      error: "#FFFF00",
    },
    menu: {
      default: "#FFFF00",
      hover: "#FFFF00",
      selected: "#FFFF00",
      emphasized: "#FFFF00",
    },
    input: {
      default: {
        default: "#FFFF00",
        focused: "#FFFF00",
      },
      chrome: {
        default: "#FFFF00",
        focused: "#FFFF00",
        hover: "#FFFF00", // TODO: Not in Figma
      },
      onAccent: {
        default: "#FFFF00",
        focused: "#FFFF00",
      },
      inline: {
        default: "#FFFF00", // TODO: Not in Figma
        hover: "#FFFF00", // TODO: Not in Figma
        focused: "#FFFF00", // TODO: Not in Figma
      },
    },
    message: {
      user: "#FFFF00",
      mem: "#FFFF00",
    },
    badge: {
      default: "#FFFF00",
      emphasis: "#FFFF00",
      moreEmphasis: "#FFFF00",
      notification: "#FFFF00",
      danger: "#FFFF00",
    },
    banner: {
      danger: "#FFFF00",
      emphasis: "#FFFF00",
      default: "#FFFF00",
    },
    card: {
      emphasis: "#FFFF00",
      default: "#FFFF00",
    },
    illustration: {
      default: "#FFFF00",
      onAccent: "#FFFF00",
      contrast: "#FFFF00",
    },
    voice: {
      self: "#FF00FF",
      others: "#FFFF00",
    },
    button: {
      default: {
        default: "#FFFF00", // TODO: Not in Figma
        hover: "#FFFF00", // TODO: Not in Figma
      },
      contrast: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      chip: {
        default: "#FFFF00",
        hover: "#FFFF00",
        selectedNegative: "#FFFF00",
        selectedPositive: "#FFFF00",
      },
      toggle: {
        default: "#FFFF00",
        hover: "#FFFF00",
        toggled: "#FFFF00",
        toggledHover: "#FFFF00",
      },
      contrastAccent: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      emphasis: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      transparent: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      navigation: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      chrome: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      subtle: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      danger: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      tabBar: {
        active: "#FFFF00",
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      brand: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      onChrome: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      onAccent: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      emphasisLight: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      dangerFilled: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      contextChipFromUser: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      contextChipFromMem: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
      floatingIcon: {
        default: "#FFFF00",
        hover: "#FFFF00",
      },
    },
    skeleton: {
      start: "#FFFF00",
      middle: "#FFFF00",
      end: "#FFFF00",
    },
  },
};

export type IMDSColors = typeof MDSColors;
